import React from "react";

// Single compact status bar — replaces KPI tiles + duplicated quick filters.
// All numbers come from GET /clients/list on the SAME filtered universe:
// counts_by_status, new_count (unread leads) and attention_count (dedup ids).
export default function ClientsStatusBar({ value, onChange, counts, unreadCount, attentionTotal }) {
  const chips = [
    { key: "attention", label: "Da gestire", n: attentionTotal ?? 0, tone: "amber" },
    { key: "new", label: "Nuove", n: unreadCount ?? 0, tone: "rose" },
    { key: "all", label: "Tutti", n: counts?.all ?? 0 },
    { key: "draft", label: "Bozze", n: counts?.draft ?? 0 },
    { key: "quote_sent", label: "Preventivi inviati", n: counts?.quote_sent ?? 0 },
    { key: "contract_signed", label: "Contratti firmati", n: counts?.contract_signed ?? 0 },
    { key: "completed", label: "Matrimoni completati", n: counts?.completed ?? 0 },
    { key: "rejected", label: "Rifiutati", n: counts?.rejected ?? 0 },
  ];
  return (
    <div className="-mx-1 px-1 flex gap-2 overflow-x-auto pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:flex-wrap md:overflow-visible" data-testid="clients-status-bar">
      {chips.map((ch) => {
        const active = value === ch.key;
        const isNew = ch.key === "new";
        const base = active
          ? isNew ? "bg-rose-600 border-rose-600 text-white" : "bg-primary border-primary text-white"
          : isNew && ch.n > 0 ? "bg-rose-50 border-rose-200 text-rose-800 hover:border-rose-300"
          : ch.key === "attention" && ch.n > 0 ? "bg-amber-50 border-amber-200 text-amber-900 hover:border-amber-300"
          : "bg-white border-border text-neutral-700 hover:border-neutral-300";
        const pill = active
          ? "bg-white/20 text-white"
          : isNew && ch.n > 0 ? "bg-rose-600 text-white"
          : ch.key === "attention" && ch.n > 0 ? "bg-amber-500 text-white"
          : "bg-neutral-100 text-neutral-600";
        return (
          <button
            key={ch.key}
            type="button"
            onClick={() => onChange(ch.key)}
            aria-pressed={active}
            className={`inline-flex items-center gap-2 h-9 pl-3 pr-1.5 rounded-full border text-[13px] whitespace-nowrap shrink-0 transition-colors ${base}`}
            data-testid={`status-chip-${ch.key}`}
          >
            {ch.label}
            <span className={`min-w-[24px] h-6 px-1.5 rounded-full text-[11px] font-semibold inline-flex items-center justify-center tabular-nums ${pill}`}>{ch.n}</span>
          </button>
        );
      })}
    </div>
  );
}
